export default function defaultAnswer(ddb_id) {

    var $radio = $('#' + ddb_id + ' [type=radio]');

    if (!$radio.is(":checked")) {

        $radio.first().click();
        
    }

}